var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"obi-tab-menu"},[_c('div',{staticClass:"menu-item-wrapper"},[_c('div',{staticClass:"menu-item-items"},[_c('ObiSidebar',{staticClass:"sideber-wrapper"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }